export enum AppStateEnum {
    'loading' = 'loading',
    'initialized' = 'initialized',
    'error' = 'error',
  }
